/**
 * Path segments after `getBaseUrl()` (…/v1) for `useApiClient` get/post/put/delete.
 * Do not prefix `/api/v1` — `useApiSendRequest` joins these with `getBaseUrl()`.
 */
export const apiV1Paths = {
	public: {
		health: "public/health",
		config: "public/config",
		siteConfig: "public/site-config",
		subscriptionPlans: "public/subscription-plans",
		thirdPartyRefreshToken: "public/third-party/refresh-token",
	},
	idnot: {
		refreshToken: "idnot/user/auth/refresh-token",
	},
	notary: {
		folders: "notary/folders",
		users: "notary/users",
		offices: "notary/offices",
		customers: "notary/customers",
		documents: "notary/documents",
		roles: "notary/roles",
	},
	customer: {
		folders: "customer/folders",
		refreshToken: "customer/auth/refresh-token",
	},
	admin: {
		metricsKpis: "admin/metrics/kpis",
		monthlyCreations: "admin/metrics/monthly-creations",
		subscriptionSeatManagementSummary: "admin/subscriptions/seat-management-summary",
		subscriptionOfficeSeatDirectory: "admin/subscriptions/office-seat-directory",
		officesActivityExport: "admin/subscriptions/offices-activity-export",
		officesActivityHistory: "admin/subscriptions/offices-activity-history",
		subscriptions: "admin/subscriptions",
		subscriptionPlans: "admin/subscription-plans",
		stripe: "admin/stripe",
		stripeReconcileOffice: "admin/stripe/reconcile-office",
		stripeEvents: "admin/stripe/events",
		stripeInvoices: "admin/stripe/invoices",
		stripePaymentIntents: "admin/stripe/payment-intents",
	},
	superAdmin: {
		roles: "super-admin/roles",
		rules: "super-admin/rules",
		officeRoles: "super-admin/office-roles",
	},
} as const;
